module.exports = __webpack_public_path__ + "img/streetsweeper_driving.781b50e0.svg";